



















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Banner } from '@/components';
import BottomTabbar from './components/BottomTabbar.vue';
import { isWeiXin } from '@/common/ts/common';
import { Button, Dialog, Toast, Popup } from 'vant';
import { getBaseInfo } from './api/index';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
import * as config from './config';
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  pointOut = false;
  option = config.OPTHINES;
  async created() {
    this.judgeInWx();
    getBaseInfo().then((res: any) => {
      this.$addPv(res.data.activityId, 9);
      console.log('活动id', res.data.activityId);
    });
    this.$addPv(405, 3660);
    // 分享
    setTimeout(() => {
      this.$appShareInfo({
        title: '《重庆市城市园林绿化条例》有奖知识竞赛',
        url: window.location.href,
        subtitle:
          '我正在参加《重庆市城市园林绿化条例》有奖知识竞赛，邀请你快来参加吧',
        classId: -1,
        id: -1,
        image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
        type: 3,
      });
    }, 500);
    this.$wxShareInfo({
      title: '《重庆市城市园林绿化条例》有奖知识竞赛',
      subtitle:
        '《我正在参加《重庆市城市园林绿化条例》有奖知识竞赛，邀请你快来参加吧',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  judgeInWx() {
    if (isWeiXin() || !window.udid) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
}
